import { TFunction } from 'i18next';
import { HumanModerationStatus } from '@/api/entities/moderation';

export const getModerateText = (
  t: TFunction<undefined>,
  isModerateMandatory: boolean,
  moderationStatus: string,
) => {
  if (
    moderationStatus === HumanModerationStatus.MODERE &&
    isModerateMandatory
  ) {
    return t('inspection:moderationMandatoryDone');
  }
  if (
    moderationStatus === HumanModerationStatus.A_MODERER &&
    isModerateMandatory
  ) {
    return t('inspection:moderationMandatoryNotDone');
  }
  if (
    moderationStatus === HumanModerationStatus.MODERE &&
    !isModerateMandatory
  ) {
    return t('inspection:moderationOptionalDone');
  }
  if (
    moderationStatus === HumanModerationStatus.A_MODERER &&
    !isModerateMandatory
  ) {
    return t('inspection:moderationOptionalNotDone');
  }
  return '';
};
